import Vue from 'vue'
import 'babel-polyfill'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import request from '@/utils/request'
// import { getCookieDecrypt } from '@/utils/util'

import VueLazyload from 'vue-lazyload'

// 移动端公共样式、会转成vw
import '@/assets/css-mobile/common.scss'

// or with options
const loadimage = require('@assets/images/lazyLoading.gif')
const errorimage = require('@assets/images/error.jpg')
Vue.use(VueLazyload, {
  // preLoad: 1.3, //提前加载高度（数字 1 表示 1 屏的高度）
  error: errorimage,
  loading: loadimage,
  // attempt: 3  // 加载错误后最大尝试次数
})


let isMobile = false
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  isMobile = true
} else {
  isMobile = false
}
// store.dispatch('TogglePlat', isMobile)
Vue.prototype._isMobile = isMobile
// console.log(111, Vue.prototype._isMobile)

//弹出框禁止滑动
Vue.prototype.stopScroll = function () {
  document.body.style.overflow = 'hidden'
}
//弹出框可以滑动
Vue.prototype.canScroll = function () {
  document.body.style.overflow = ''// 出现滚动条
}

Vue.use(ElementUI)
Vue.prototype.$http = request

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  fullscreenEl: false,
  zoomEl: false
})

//全局组件
import GL_Component from '@/utils/globalComponents'
Vue.use(GL_Component)

router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0)
  // document.getElementById('app').scrollTop = 0

  // console.log(1, from)
  // console.log(2, to)
  // ?platform=minipro
  if(to.query.platform == 'minipro') {
    // 微信小程序跳转而来
    store.dispatch('setPlat', 'minipro')

    console.log('---', store.state.platform)
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
